// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portrait[data-v-6a0811ca]{border-radius:50%;height:100%;width:100%;overflow:hidden;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
